export default class TagsModel {
  constructor (data) {
    this.id = data.id
    this.key = data.id
    this.value = data.value
    this.title = this.value
    this.name = data.name
    this.count = 4
  }
}



// WEBPACK FOOTER //
// ./src/api/tags/TagsModel.js